import moment from 'moment'

import BaseDayPicker from 'modules/core/components/DayPicker'
import i18n from 'modules/core/lib/i18n'

interface Props {
  error?: boolean
  label: string
  mandatory?: boolean
  selectedDate: string | undefined
  handleSelectedDatesChange: (date: string | undefined) => void
  minDate?: string
  maxDate?: string
}

export const DayPicker = ({
  error,
  label,
  mandatory,
  selectedDate,
  minDate,
  maxDate,
  handleSelectedDatesChange,
}: Props) => {
  return (
    <BaseDayPicker
      mode="single"
      label={label}
      mandatory={!!mandatory}
      value={selectedDate}
      format="ui"
      valueFormat="backend"
      minDate={minDate ? moment(minDate) : undefined}
      maxDate={maxDate ? moment(maxDate) : undefined}
      onChange={handleSelectedDatesChange}
      {...(!mandatory && {
        secondaryLabel: `(${i18n.t('common.optional')})`,
        withNull: true,
        withNullButtonLabel: selectedDate
          ? i18n.t('finance.cost_centers.assignments.day_picker.clear')
          : i18n.t('common.cancel'),
      })}
      {...(error && { error: ' ' })}
    />
  )
}
